import { Content } from "../../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../../general/modules/commons/content/contentHeader";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderActions,
  LayoutHeaderTitle,
} from "../../../../general/modules/commons/layout/layout";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../../general/modules/commons/breadcrumb/breadcrumb";
import { useAppDispatch } from "../../../../../hooks/useTypedSelector";
import { logout } from "../../../../auth/infrastructure/slices/authSlice/authSlice";
import useCrudTable from "../../../../../hooks/useCrudTable";
import { PositionTableColumns } from "../../domain/columns/positionTableColumns";
import { positionSchema } from "../../domain/schemas/positionSchema";
import useCrudFilters from "../../../../../hooks/useCrudFilters";
import { useTranslation } from "react-i18next";
import { PositionTableFilters } from "../features/positionTableFilters";
import { useCrudExport } from "../../../../../hooks/useCrudExport";

export const PositionPage = () => {
  const { t } = useTranslation("common");

  const dispatch = useAppDispatch();

  const title = t("Positions");

  const crudFilters = useCrudFilters(
    {
      searchBy: "SearchByRootPosition",
      fields: {},
    },
    "positionFilter",
  );

  const crud = useCrudTable({
    prefix: "positions",
    entity: "Position",
    columns: PositionTableColumns,
    schema: positionSchema,
    addAction: "/positions/add",
    columnAction: "/positions/edit/:id",
    filters: crudFilters.filters,
  });

  const exportPosition = useCrudExport({
    pageCount: crud.tableInstance.getPageCount(),
    queryFunction: "exportPositions",
    queryData: [
      "position",
      { shelvingUnit: ["identifier"] },
      { shelvingUnit: [{ path: ["identifier"] }] },
      { shelvingUnit: [{ path: [{ warehouse: ["name", "status"] }] }] },
      {
        tiresets: ["type", { car: ["licence", { relation: ["name"] }] }],
      },
    ],
    filters: crudFilters.filters,
  });

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem>{title}</BreadCrumbItem>
          </Breadcrumb>
          <LayoutHeaderActions>
            {crud.addButton}
            {exportPosition.exportButton}
          </LayoutHeaderActions>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader title={title} className="mb-3" />
          <PositionTableFilters {...crudFilters} />
          {crud.table}
        </Content>
      </LayoutContent>
    </Layout>
  );
};
